import request from '@/utils/request'

//获取租户余额
export function getTenant() {
    return request({
      url: '/system/tenant/get',
      method: 'get'
    })
  }


// WEBPACK FOOTER //
// ./src/api/tenant.js